import { render, staticRenderFns } from "./PartnerPrimaryDocsList.vue?vue&type=template&id=3b0281bb&scoped=true&"
import script from "./PartnerPrimaryDocsList.vue?vue&type=script&lang=js&"
export * from "./PartnerPrimaryDocsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0281bb",
  null
  
)

export default component.exports